import { assertNumber, genericDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../../__generated/admin-implementation.js';
/**
 * These can not be auto-generated from YAML because the control displays the countersink diameter,
 * but the property stored is the radius.
 */ export const countersinkComponents = [
    attachAdminComponent.withComponent(genericDimensionComponent, 'topRadius').withEntity('Countersink').attach(memoEval((self)=>[
            self.topRadius
        ], (topRadius)=>({
            value: topRadius * 2,
            min: 0.5,
            max: 100,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        // TODO: can we ditch this and use diameter directly? So it can be moved to yaml...
        return {
            topRadius: state.value / 2
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'bottomRadius').withEntity('Countersink').attach(memoEval((self)=>[
            self.bottomRadius
        ], (bottomRadius)=>({
            value: bottomRadius * 2,
            min: 0.5,
            max: 100,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        // TODO: can we ditch this and use diameter directly? So it can be moved to yaml...
        return {
            bottomRadius: state.value / 2
        };
    })
];

//# sourceMappingURL=countersink.js.map